export default __webpack_public_path__ + "static/media/myPicture.1ddd025e.jpeg";